// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-wrapper{width:100%;padding:.5rem 0;cursor:pointer;transform-origin:left center}.timeline-wrapper__timeline{width:100%;height:2px;background-color:hsla(0,0%,100%,.3);transform-origin:left center}.timeline-wrapper__timeline__progress{width:0;background-color:#fff;height:100%}", ""]);
// Exports
module.exports = exports;
